<template>
  <div class="login-page">
    <!-- Background Animation -->
    <div class="background-animation">
      <div class="circle circle-1"></div>
      <div class="circle circle-2"></div>
      <div class="circle circle-3"></div>
    </div>

    <div class="login-container">
      <div class="login-box">
        <!-- Logo Section -->
        <div class="logo-section">
          <img src="assets/img/cyanlogo.png" alt="CYAN Waterpark" class="logo">
        </div>

        <!-- Welcome Text -->
        <div class="welcome-text">
          <h2>{{ $t('login_cyan.login_here') }}</h2>
          <p>Welcome back! Please enter your mobile number</p>
        </div>

        <!-- Login Form -->
        <form @submit.prevent="handleSubmit" class="login-form">
          <div class="input-group">
            <label for="mobile">{{ $t('login_cyan.mobile_number') }}</label>
            <div class="phone-input">
              <span class="country-code">+966</span>
              <input
                type="tel"
                id="mobile"
                v-model="mobileNumber"
                :placeholder="$t('login_cyan.enter_mobile_number')"
                pattern="[0-9]*"
                maxlength="9"
                required
              >
            </div>
          </div>

          <button type="submit" class="login-btn">
            {{ $t('login_cyan.log_in') }}
            <i class="fas fa-arrow-right"></i>
          </button>
        </form>

        <!-- Terms Text -->
        <p class="terms-text">
          By logging in, you agree to our 
          <RouterLink to="/terms-and-condition">Terms & Conditions</RouterLink> 
          and <RouterLink to="/privacy">Privacy Policy</RouterLink>
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import axiosInstance from '@/plugins/axios';
import { ref } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();
const mobileNumber = ref('');

const handleSubmit = async () => {
  const regex = new RegExp(/^(009665|9665|\+9665|05|5)(5|0|3|6|4|9|1|8|7)([0-9]{7})$/);
  if (regex.test(mobileNumber.value)) {
    const ressponse = await axiosInstance.post('/api/sendOtp', { phone: mobileNumber.value });
    if(ressponse.status === 200) {
      localStorage.setItem('mobile', mobileNumber.value);
      router.push({ 
        name: 'LoginOtp', 
        params: { mobile: mobileNumber.value }
      });
    }
  } else {
    alert('Please enter a valid 9-digit mobile number.');
  }
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #1268B1, #0d4f8c);
}

/* Background Animation */
.background-animation {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 0;
  overflow: hidden;
}

.circle {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  animation: float 15s infinite;
}

.circle-1 {
  width: 400px;
  height: 400px;
  top: -100px;
  right: -100px;
  animation-delay: 0s;
}

.circle-2 {
  width: 300px;
  height: 300px;
  bottom: -50px;
  left: -50px;
  animation-delay: -5s;
}

.circle-3 {
  width: 200px;
  height: 200px;
  bottom: 50%;
  right: 30%;
  animation-delay: -10s;
}

@keyframes float {
  0% {
    transform: translate(0, 0) rotate(0deg);
  }
  33% {
    transform: translate(30px, -50px) rotate(120deg);
  }
  66% {
    transform: translate(-20px, 20px) rotate(240deg);
  }
  100% {
    transform: translate(0, 0) rotate(360deg);
  }
}

.login-container {
  width: 100%;
  max-width: 450px;
  margin: 20px;
  position: relative;
  z-index: 1;
}

.login-box {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  padding: 40px;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.logo-section {
  text-align: center;
  margin-bottom: 30px;
}

.logo {
  height: 60px;
  width: auto;
}

.welcome-text {
  text-align: center;
  margin-bottom: 30px;
}

.welcome-text h2 {
  color: #1268B1;
  font-size: 24px;
  margin-bottom: 10px;
}

.welcome-text p {
  color: #666;
  font-size: 16px;
}

.login-form {
  margin-bottom: 20px;
}

.input-group {
  margin-bottom: 25px;
}

.input-group label {
  display: block;
  margin-bottom: 8px;
  color: #333;
  font-weight: 500;
}

.phone-input {
  display: flex;
  align-items: center;
  border: 2px solid #e1e1e1;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.phone-input:focus-within {
  border-color: #1268B1;
}

.country-code {
  background: #f5f5f5;
  padding: 12px 15px;
  color: #333;
  font-weight: 600;
  border-right: 2px solid #e1e1e1;
}

.phone-input input {
  flex: 1;
  padding: 12px 15px;
  border: none;
  outline: none;
  font-size: 16px;
  background: transparent;
}

.login-btn {
  width: 100%;
  padding: 14px;
  background: #1268B1;
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.login-btn:hover {
  background: #0d4f8c;
  transform: translateY(-2px);
}

.terms-text {
  text-align: center;
  font-size: 14px;
  color: #666;
  margin-top: 20px;
}

.terms-text a {
  color: #1268B1;
  text-decoration: none;
}

.terms-text a:hover {
  text-decoration: underline;
}

/* Responsive Design */
@media (max-width: 768px) {
  .login-box {
    padding: 30px 20px;
  }

  .logo {
    height: 50px;
  }

  .welcome-text h2 {
    font-size: 22px;
  }

  .welcome-text p {
    font-size: 14px;
  }
}

/* RTL Support */
[dir="rtl"] .welcome-text {
  text-align: right;
}

[dir="rtl"] .input-group label {
  text-align: right;
}

[dir="rtl"] .phone-input input {
  text-align: right;
}

[dir="rtl"] .terms-text {
  text-align: right;
}
</style>